module.exports = __webpack_public_path__ + "img/icon-back-to-top.f9ce3267.svg";